

// import React from "react";
// import { Container, Navbar, Nav } from "react-bootstrap";

// const TopBar = () => (
//   <div style={{ backgroundColor: "#5c6470", color: "white", fontSize: "14px", padding: "5px 0" }}>
//     <Container className="d-flex justify-content-end">
//       +1 (234) 567 89 00
//       <div className="ms-3 d-flex gap-2">
//         <a href="#" style={{ color: "white" }} aria-label="Facebook">
//           <i className="bi bi-facebook"></i>
//         </a>
//         <a href="#" style={{ color: "white" }} aria-label="Instagram">
//           <i className="bi bi-instagram"></i>
//         </a>
//         <a href="#" style={{ color: "white" }} aria-label="YouTube">
//           <i className="bi bi-youtube"></i>
//         </a>
//       </div>
//     </Container>
//   </div>
// );

// const MainNavbar = () => (
//   <Navbar bg="white" expand="lg" className="py-3">
//     <Container>
//       <Navbar.Brand href="#" style={{ fontFamily: "'Great Vibes', cursive", fontSize: "28px" }}>
//         Crimon
//       </Navbar.Brand>
//       <Navbar.Toggle aria-controls="basic-navbar-nav" />
//       <Navbar.Collapse id="basic-navbar-nav">
//         <Nav className="mx-auto">
//           {[
//             "About us",
//             "Our services",
//             "Events",
//             "Virtual tours",
//             "Packages",
//             "Testimonials",
//             "FAQ",
//             "Contacts",
//           ].map((item, idx) => (
//             <React.Fragment key={item}>
//               <Nav.Link href="#" style={{ color: "#333", fontWeight: "500" }}>
//                 {item}
//               </Nav.Link>
//               {idx !== 7 && <span className="text-muted mx-2">|</span>}
//             </React.Fragment>
//           ))}
//         </Nav>
//       </Navbar.Collapse>
//     </Container>
//   </Navbar>
// );

// export default function Header() {
//   return (
//     <>
//       <TopBar />
//       <MainNavbar />
//     </>
//   );
// }
// import React, { useState, useEffect } from "react";
// import { Navbar, Nav, Container } from "react-bootstrap";
// import { NavLink, useLocation } from "react-router-dom";

// export default function Header() {
//   const [scrolled, setScrolled] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const location = useLocation();

//   const isHomePage = location.pathname === "/";

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 80);
//     };

//     if (isHomePage) {
//       window.addEventListener("scroll", handleScroll);
//     }

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [isHomePage]);
// const navLinkStyle = ({ isActive }) => ({
//   color: expanded
//     ? isActive
//       ? "#ff3b1f"
//       : "white"
//     : isHomePage
//     ? isActive
//       ? "#ff3b1f"
//       : "white"
//     : isActive
//     ? "#ff3b1f"
//     : "black",
//   textDecoration: "none",
//   margin: "0 18px",
//   fontSize: "17px",
//   fontWeight: "500",
//   transition: "0.3s ease",
// });

//   const navbarBackground = isHomePage
//     ? scrolled || expanded
//       ? "rgba(0,0,0,0.95)"
//       : "transparent"
//     : "white";

//   return (
//     <Navbar
//       expand="lg"
//       fixed="top"
//       expanded={expanded}
//       onToggle={(isOpen) => setExpanded(isOpen)}
//       style={{
//         background: navbarBackground,
//         transition: "all 0.4s ease",
//         padding: "18px 0",
//         zIndex: 1000,
//       }}
//     >
//       <Container>
//         <Navbar.Brand
//           style={{
//             color: isHomePage ? "white" : "black",
//             fontSize: "32px",
//             fontWeight: "700",
//             marginRight: "90px",
            
//           }}
//         >
//           Sangam Marriage Hall
//         </Navbar.Brand>

//         <Navbar.Toggle
//           aria-controls="basic-navbar-nav"
//           style={{
//             backgroundColor: "white",
//             border: "none",
//           }}
//         />

//         <Navbar.Collapse
//           id="basic-navbar-nav"
//           className="justify-content-center"
//           style={{
//             backgroundColor: expanded ? "rgba(0,0,0,0.95)" : "transparent",
//             marginTop: "10px",
//             padding: expanded ? "15px" : "0",
//             borderRadius: "12px",
//           }}
//         >
//           <Nav className="text-center w-100">
//             <NavLink
//               to="/"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Home
//             </NavLink>

//             {/* <NavLink
//               to="/about"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               About Us
//             </NavLink> */}

//             <NavLink
//   to="/about"
//   style={navLinkStyle}
//   onClick={() => setExpanded(false)}
// >
//   <span style={{ whiteSpace: "nowrap" }}>About Us</span>
// </NavLink>

//             <NavLink
//               to="/services"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Services
//             </NavLink>

//             {/* <NavLink
//               to="/gallery"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Gallery
//             </NavLink> */}
//                 <NavLink
//               to="/contact"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//         <span style={{whiteSpace:"nowrap"}}>Contact Us</span>
//             </NavLink>

//             {/* <NavLink
//               to="/pricing"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//         <span style={{whiteSpace:"nowrap"}}> Pricing Packages</span>
//             </NavLink> */}
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { Navbar, Nav, Container } from "react-bootstrap";
// import { NavLink, useLocation } from "react-router-dom";
// import Logo from "../../Images/Logo1.png";

// export default function Header() {
//   const [scrolled, setScrolled] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const location = useLocation();

//   const isHomePage = location.pathname === "/";

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 80);
//     };

//     if (isHomePage) {
//       window.addEventListener("scroll", handleScroll);
//     }

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [isHomePage]);

//   const navLinkStyle = ({ isActive }) => ({
//     color: expanded
//       ? isActive
//         ? "#ff3b1f"
//         : "white"
//       : isHomePage
//       ? isActive
//         ? "#ff3b1f"
//         : "white"
//       : isActive
//       ? "#ff3b1f"
//       : "black",
//     textDecoration: "none",
//     margin: "0 18px",
//     fontSize: "17px",
//     fontWeight: "500",
//     transition: "0.3s ease",
//   });

//   const navbarBackground = isHomePage
//     ? scrolled || expanded
//       ? "rgba(0,0,0,0.95)"
//       : "transparent"
//     : "white";

//   return (
//     <Navbar
//       expand="lg"
//       fixed="top"
//       expanded={expanded}
//       onToggle={(isOpen) => setExpanded(isOpen)}
//       style={{
//         background: navbarBackground,
//         transition: "all 0.4s ease",
//         height: "120px",
//         padding: "0",
//         zIndex: 1000,
//         display: "flex",
//         alignItems: "center",
//       }}
//     >
//       <Container
//         style={{
//           height: "100%",
//           display: "flex",
//           alignItems: "center",
//         }}
//       >
//         <Navbar.Brand
//        style={{
//   marginRight: "70px",
//   height: "90px",
//   display: "flex",
//   alignItems: "center",
//   overflow: "visible",
// }}
//         >
//           <img
//             src={Logo}
//             alt="Sangam Marriage Hall"
//            style={{
//   height: "100px",
//   width: "200px",
//   objectFit: "contain",
//   display: "block",
// }}
//           />
//         </Navbar.Brand>

//         <Navbar.Toggle
//           aria-controls="basic-navbar-nav"
//           style={{
//             backgroundColor: "white",
//             border: "none",
//           }}
//         />

//         <Navbar.Collapse
//           id="basic-navbar-nav"
//           className="justify-content-center"
//           style={{
//             backgroundColor: expanded
//               ? "rgba(0,0,0,0.95)"
//               : "transparent",
//             marginTop: "0",
//             padding: expanded ? "15px" : "0",
//             borderRadius: "12px",
//             justifyContent: "center",
//           }}
//         >
//           <Nav
//             className="w-100"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//             }}
//           >
//             <NavLink
//               to="/"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Home
//             </NavLink>

//             <NavLink
//               to="/about"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               <span style={{ whiteSpace: "nowrap" }}>About Us</span>
//             </NavLink>

//             <NavLink
//               to="/services"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Services
//             </NavLink>

//             <NavLink
//               to="/contact"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               <span style={{ whiteSpace: "nowrap" }}>Contact Us</span>
//             </NavLink>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }


// import React, { useState, useEffect } from "react";
// import { Navbar, Nav, Container } from "react-bootstrap";
// import { NavLink, useLocation } from "react-router-dom";
// import Logo from "../../Images/Logo1.png";

// export default function Header() {
//   const [scrolled, setScrolled] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const location = useLocation();

//   const isHomePage = location.pathname === "/";

//   useEffect(() => {
//     const handleScroll = () => {
//       setScrolled(window.scrollY > 80);
//     };

//     if (isHomePage) {
//       window.addEventListener("scroll", handleScroll);
//     }

//     return () => {
//       window.removeEventListener("scroll", handleScroll);
//     };
//   }, [isHomePage]);

//   const navLinkStyle = ({ isActive }) => ({
//     color: expanded
//       ? isActive
//         ? "#ff3b1f"
//         : "white"
//       : isHomePage
//       ? isActive
//         ? "#ff3b1f"
//         : "white"
//       : isActive
//       ? "#ff3b1f"
//       : "black",
//     textDecoration: "none",
//     margin: expanded ? "10px 0" : "0 14px",
//     fontSize: expanded ? "18px" : "16px",
//     fontWeight: "500",
//     transition: "0.3s ease",
//   });

//   const navbarBackground = isHomePage
//     ? scrolled || expanded
//       ? "rgba(0,0,0,0.95)"
//       : "transparent"
//     : "white";

//   return (
//     <Navbar
//       expand="lg"
//       fixed="top"
//       expanded={expanded}
//       onToggle={(isOpen) => setExpanded(isOpen)}
//       style={{
//         background: navbarBackground,
//         transition: "all 0.4s ease",
//         minHeight: "80px",
//         height: "auto",
//         padding: "10px 0",
//         zIndex: 1000,
//         display: "flex",
//         alignItems: "center",
//       }}
//     >
//       <Container
//         fluid
//         style={{
//           display: "flex",
//           alignItems: "center",
//           padding: "0 20px",
//         }}
//       >
      
//         <Navbar.Brand
//           style={{
//             marginRight: "auto",
//             display: "flex",
//             alignItems: "center",
//           }}
//         >
//          <img
//   src={Logo}
//   alt="Sangam Marriage Hall"
//   style={{
//     height: "auto",
//     maxHeight: "70px",
//     width: "auto",
//     maxWidth: "160px",
//     objectFit: "contain",
//     borderRadius: "40px",
  
//   }}
// />
//         </Navbar.Brand>

        
//         <Navbar.Toggle
//           aria-controls="basic-navbar-nav"
//           style={{
//             backgroundColor: "transparent",
//             border: "1px solid #ddd",
         
//             padding: "6px 10px",
//           }}
//         />

   
//         <Navbar.Collapse
//           id="basic-navbar-nav"
//           style={{
//             backgroundColor: expanded
//               ? "rgba(0,0,0,0.95)"
//               : "transparent",
//             marginTop: expanded ? "10px" : "0",
//             padding: expanded ? "15px" : "0",
//             borderRadius: "12px",
//             boxShadow: expanded
//               ? "0 4px 10px rgba(0,0,0,0.3)"
//               : "none",
//           }}
//         >
//           <Nav
//             className="w-100"
//             style={{
//               display: "flex",
//               justifyContent: "center",
//               alignItems: "center",
//               flexDirection: expanded ? "column" : "row",
//               gap: expanded ? "12px" : "0",
//             }}
//           >
//             <NavLink
//               to="/"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Home
//             </NavLink>

//             <NavLink
//               to="/about"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               About Us
//             </NavLink>

//             <NavLink
//               to="/services"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Services
//             </NavLink>

//             <NavLink
//               to="/contact"
//               style={navLinkStyle}
//               onClick={() => setExpanded(false)}
//             >
//               Contact Us
//             </NavLink>
//           </Nav>
//         </Navbar.Collapse>
//       </Container>
//     </Navbar>
//   );
// }



import React, { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import Logo from "../../Images/Logo1.png";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);

  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 992);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 80);
    };

    if (isHomePage) {
      window.addEventListener("scroll", handleScroll);
    }

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHomePage]);

  const navLinkStyle = ({ isActive }) => ({
    color: expanded
      ? isActive
        ? "#ff3b1f"
        : "white"
      : isHomePage
      ? isActive
        ? "#ff3b1f"
        : "white"
      : isActive
      ? "#ff3b1f"
      : "black",
    textDecoration: "none",
    margin: isMobile ? "10px 0" : "0 18px",
    fontSize: isMobile ? "18px" : "17px",
    fontWeight: "500",
    transition: "0.3s ease",
  });

  const navbarBackground = isHomePage
    ? scrolled || expanded
      ? "rgba(0,0,0,0.95)"
      : "transparent"
    : "white";

  const hamburgerColor = isHomePage ? "#fff" : "#000";

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={(isOpen) => setExpanded(isOpen)}
      style={{
        background: navbarBackground,
        transition: "all 0.4s ease",
        minHeight: "80px",
        padding: "10px 0",
        display: "flex",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <Container
        fluid
        style={{
          display: "flex",
          alignItems: "center",
          padding: "0 20px",
        }}
      >
     
        <Navbar.Brand>
          <img
            src={Logo}
            alt="Sangam Marriage Hall"
            style={{
              height: "auto",
              maxHeight: "70px",
              width: "auto",
              maxWidth: "160px",
              objectFit: "contain",
              borderRadius: "40px",
            }}
          />
        </Navbar.Brand>

    
        {isMobile && (
          <Navbar.Toggle
            aria-controls="basic-navbar-nav"
            onClick={() => setExpanded(!expanded)}
            style={{
              backgroundColor: "transparent",
              border: `1px solid ${hamburgerColor}`,
              padding: "8px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "30px",
            }}
          >
            <span
              style={{
                width: "25px",
                height: "2px",
                backgroundColor: hamburgerColor,
              }}
            />
            <span
              style={{
                width: "25px",
                height: "2px",
                backgroundColor: hamburgerColor,
              }}
            />
            <span
              style={{
                width: "25px",
                height: "2px",
                backgroundColor: hamburgerColor,
              }}
            />
          </Navbar.Toggle>
        )}

     
        <Navbar.Collapse
          id="basic-navbar-nav"
          style={{
            backgroundColor: expanded ? "rgba(0,0,0,0.95)" : "transparent",
            marginTop: expanded ? "10px" : "0",
            padding: expanded ? "15px" : "0",
            borderRadius: "12px",
          }}
        >
          <Nav
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: isMobile ? "column" : "row",
              width: "100%",
            }}
          >
            <NavLink to="/" style={navLinkStyle} onClick={() => setExpanded(false)}>
              Home
            </NavLink>

            <NavLink to="/about" style={navLinkStyle} onClick={() => setExpanded(false)}>
              About Us
            </NavLink>

            <NavLink to="/services" style={navLinkStyle} onClick={() => setExpanded(false)}>
              Services
            </NavLink>

            <NavLink to="/contact" style={navLinkStyle} onClick={() => setExpanded(false)}>
              Contact Us
            </NavLink>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}